import { jsx as e } from "@emotion/react/jsx-runtime";
import { StyledHeader as o } from "./Header.styled.js";
const d = ({
  children: r
}) => /* @__PURE__ */ e(o, { children: r });
export {
  d as Header
};
